// Must be imported FIRST — patches window.addEventListener before React Router registers its popstate listener
import './popstate-guard';
import { RouterProvider } from 'react-router';
import { Toaster } from 'sonner';
import { DataProvider } from './data/DataContext';
import { AuthProvider } from './data/AuthContext';
import { getRouter } from './routes';

export default function App() {
  return (
    <DataProvider>
      <AuthProvider>
        <RouterProvider router={getRouter()} />
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </DataProvider>
  );
}